import { Directive, HostListener, output } from '@angular/core';

@Directive({
  selector: 'tui-tiles[xTilesOrder]',
})
export class TilesOrderDirective {
  private pendingOrder: Map<number, number> | null = null;
  private dragging = false;
  private waitingForLateOrder = false;

  orderChangeFinished = output<Map<number, number>>();

  @HostListener('pointerdown')
  onDragStart(): void {
    this.dragging = true;
    this.waitingForLateOrder = false;
    this.pendingOrder = null;
  }

  @HostListener('orderChange', ['$event'])
  onOrderChange(event: Event): void {
    const customEvent = event as unknown as Map<number, number>;

    if (this.dragging) {
      this.pendingOrder = customEvent;

      return;
    }

    if (this.waitingForLateOrder) {
      this.waitingForLateOrder = false;
      this.orderChangeFinished.emit(customEvent);
    }
  }

  @HostListener('document:mouseup')
  @HostListener('document:touchend')
  @HostListener('document:pointerup')
  @HostListener('document:pointercancel')
  onDragEnd(): void {
    if (!this.dragging) {
      return;
    }

    this.dragging = false;

    if (this.pendingOrder?.size) {
      this.orderChangeFinished.emit(this.pendingOrder);
      this.pendingOrder = null;

      return;
    }

    this.waitingForLateOrder = true;
  }
}
